<template>
    <div :id="id"
         class="backgrund-image-placement"
         style="aspect-ratio: 1 / 1"
         v-bind:style="{'background-image': 'url('+ src +')'}"></div>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'FotoCuadrada',

        props: ['src'],

        data() {
            return {
                id: null
            };
        },

        created() {
            this.id = Math.floor(Math.random() * Date.now());
        }
    }
</script>
